import { ref, push, set, update, remove, onValue } from 'firebase/database'
import { db, tref } from './firebase.js'

// Pro-shop Special Orders tracker. Persisted under /club/specialOrders (the
// /club node is already writable in the RTDB rules — no rules change needed).
//   {orderId}: { name, item, vendor, category, datePlaced, cost, notes,
//                status, stageHistory: { <stage>: <dateISO> }, createdAt }
const BASE = 'club/specialOrders'

export const SPECIAL_ORDER_STAGES = ['Placed', 'Ordered', 'Shipped', 'Arrived', 'Member Notified', 'Picked Up']
export const SPECIAL_ORDER_CATEGORIES = ['Clubs', 'Shoes', 'Apparel', 'Gear', 'Repair']
const today = () => new Date().toISOString().slice(0, 10)

export function watchSpecialOrders(cb) {
  return onValue(tref(BASE), (snap) => cb(snap.val() || {}))
}

export async function createSpecialOrder({ name, item, vendor, category, datePlaced, cost, notes }) {
  const n = String(name || '').trim()
  const it = String(item || '').trim()
  if (!n) throw new Error('Customer name is required.')
  if (!it) throw new Error('Item description is required.')
  const date = datePlaced || today()
  const costNum = cost === '' || cost == null ? null : Number(cost)
  if (costNum != null && !Number.isFinite(costNum)) throw new Error('Cost must be a number.')
  const node = push(tref(BASE))
  await set(node, {
    name: n,
    item: it,
    vendor: String(vendor || '').trim(),
    category: SPECIAL_ORDER_CATEGORIES.includes(category) ? category : 'Gear',
    datePlaced: date,
    cost: costNum,
    notes: String(notes || '').trim(),
    status: 'Placed',
    stageHistory: { Placed: date },
    createdAt: Date.now(),
  })
  return node.key
}

export async function updateSpecialOrder(id, patch) {
  const clean = {}
  for (const k of ['name', 'item', 'vendor', 'notes']) if (patch[k] != null) clean[k] = String(patch[k]).trim()
  if (patch.category != null) clean.category = patch.category
  if (patch.datePlaced != null) clean.datePlaced = patch.datePlaced
  if (patch.cost !== undefined) clean.cost = patch.cost === '' || patch.cost == null ? null : Number(patch.cost)
  await update(tref(`${BASE}/${id}`), clean)
}

// Move to a stage and stamp the date it was reached (deep update keeps prior stamps).
export async function setSpecialOrderStatus(id, status, date) {
  if (!SPECIAL_ORDER_STAGES.includes(status)) throw new Error('Unknown status.')
  await update(tref(`${BASE}/${id}`), {
    status,
    [`stageHistory/${status}`]: date || today(),
  })
}

export async function deleteSpecialOrder(id) {
  await remove(tref(`${BASE}/${id}`))
}
